import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageHeader } from '@ems/ui/patterns/page-header'

import { ReadOnlyNotice } from '#admin/components/read-only-notice.tsx'
import { sessionQuery } from '#admin/features/auth/queries.ts'
import { can } from '#admin/features/auth/session.ts'
import { BillingSettingsForm } from '#admin/features/billing/billing-settings-form.tsx'
import { PaymentMethodsSkeleton } from '#admin/features/billing/billing-skeletons.tsx'
import { billingSettingsQuery } from '#admin/features/billing/queries.ts'

/** `/billing/settings` — the due days and the number format of this edition's documents. */
export const Route = createFileRoute('/_authenticated/billing/settings')({
  // ponytail: the payment methods skeleton has the same shape (a header and one short block).
  pendingComponent: PaymentMethodsSkeleton,
  staticData: { crumb: { parents: [{ label: 'Billing' }], label: 'Settings' } },
  loader: ({ context }) => context.queryClient.ensureQueryData(billingSettingsQuery()),
  component: BillingSettingsPage,
})

function BillingSettingsPage() {
  const { data } = useSuspenseQuery(billingSettingsQuery())
  const { data: session } = useSuspenseQuery(sessionQuery())
  const canManage = can(session, 'billing.manage')

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Billing settings"
        description="Set when an invoice is due, and how the invoices and the credit notes are numbered."
      />
      {canManage ? null : <ReadOnlyNotice area="billing settings" />}
      <BillingSettingsForm initial={data} readOnly={!canManage} />
    </div>
  )
}
